var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.customclass,attrs:{"href":_vm.url},on:{"click":function($event){$event.preventDefault();return _vm.print_page($event)}}},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }